export default function nonITAssetDirective() {
  return {
    template: require('./nonIT-asset.html'),
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      function: '=',
      nonItAsset: '=',
      isEdit: '<',
      tooltipAppendToSelector: '@',
    },
    controller: 'NonITAssetController',
    controllerAs: 'nonITAssetVM',
    bindToController: true,
    replace: true,
  };
}
